/*eslint-disable */
import root from '@/_helpers/roots';
import axios from 'axios';
let zoomMeetingCreateApiUrl = root.zoomMeetingCreateApiUrl.link;
var $ = window.jQuery = require('jquery');
import toast from '@/services/toast';
import { Datetime } from 'vue-datetime';
// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css'
import { bus } from '@/main';
export default {
  name: 'create-vista-conf-popup',
  components: {
    datetime: Datetime
  },
  props: [
    'meetingID'
  ],
  data () {
    return {
      start_time:'',
      topic:'',
      type:'',
      duration:'',
      timezone:'', 
      agenda:'',
      submitted:false,
    }
  },
  computed: {
  },
  mounted () {
  },
  methods: {
    getVistaListAgain(){
      this.$store.dispatch('vistaConferenceListFun')
    },
    createVistaConfBeforeSubmitMethod(){
      this.$validator.validateAll().then((result) => {
        if(result){
          this.submitted =  true
          let data = {
            topic:this.topic,
            start_time:this.start_time,
            type: 2,
            duration:this.duration,
            timezone:'Asia/Calcutta',
            agenda:this.agenda
          }
          axios.post(zoomMeetingCreateApiUrl, data).then(res => {
              toast.success(res.data.msg);
              this.submitted =  false
              this.getVistaListAgain()
              this.closeVistaConfPopup()
          }).catch(err => {
              toast.error(err.data.msg);
              this.submitted =  false
          })
          return;
        }
      })
    },
    closeVistaConfPopup(){
      $('body').removeClass('body_right_scroll_remove')
      bus.$emit('vistaConfStateBus', false);
    },
  },
  watch: {
  },
}